<section class="wishlist-shell">
  <header class="wishlist-hero">
    <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
  </header>

  <ng-container *ngIf="isLoading; else wishlistContent">
    <div class="wishlist-grid">
      <article class="wishlist-grid__item" *ngFor="let _ of skeletonPlaceholders">
        <div class="wishlist-skeleton">
          <div class="wishlist-skeleton__media">
            <ngx-skeleton-loader [theme]="{
                height: '100%',
                width: '100%',
                'border-radius': '12px',
                'background-color': '#f0f0f0'
              }"></ngx-skeleton-loader>
          </div>
          <div class="wishlist-skeleton__body">
            <ngx-skeleton-loader [theme]="{
                height: '20px',
                width: '85%',
                'margin-bottom': '10px',
                'border-radius': '4px',
                'background-color': '#f0f0f0'
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader [theme]="{
                height: '16px',
                width: '45%',
                'border-radius': '4px',
                'background-color': '#f0f0f0'
              }"></ngx-skeleton-loader>
          </div>
        </div>
      </article>
    </div>
  </ng-container>

  <ng-template #wishlistContent>
    <ng-container *ngIf="productDetails.length; else emptyWishlist">
      <div class="wishlist-grid">
        <article class="wishlist-grid__item"
          *ngFor="let item of productDetails | paginate : { itemsPerPage: limit, currentPage: currentPage, totalItems: totalItems }">
          <button class="wishlist-toggle" type="button"
            (click)="toggleWishlist(item?.productId?._id); $event.stopPropagation()">
            <i class="fa" [ngClass]="item?.isLike ? 'fa-heart' : 'fa-heart-o'"></i>
          </button>
          <wishlist-card [data]="item" (on_Click)="navigateToViewProduct(item?.productId?._id)"></wishlist-card>
        </article>
      </div>

      <div class="wishlist-pagination" *ngIf="totalItems > limit">
        <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #emptyWishlist>
    <div class="wishlist-empty">
      <svg width="160" height="160" viewBox="0 0 200 200" aria-hidden="true">
        <g transform="translate(30, 30)">
          <path d="M20 20H120L110 80H40L20 20Z" fill="#F9FAFB" stroke="#BE0119" stroke-width="4"
            stroke-linejoin="round"></path>
          <circle cx="50" cy="100" r="8" fill="#BE0119"></circle>
          <circle cx="90" cy="100" r="8" fill="#BE0119"></circle>
          <circle cx="70" cy="50" r="18" fill="#BE0119"></circle>
          <path d="M62 45 Q70 40 78 45" stroke="#BE0119" stroke-width="2" fill="none"></path>
          <circle cx="65" cy="48" r="2" fill="#BE0119"></circle>
          <circle cx="75" cy="48" r="2" fill="#BE0119"></circle>
        </g>
      </svg>
      <h2>Empty Wishlist</h2>
      <p>Your wishlist is currently empty. Start exploring and add your favourite products here!</p>
      <button class="cta" [routerLink]="['/home']">Explore products</button>
    </div>
  </ng-template>
</section>